const trackUtils = require('./trackUtils');


try {
  /** exclude back view */
  if (typeof history.state === 'undefined' || history.state === null ||
      typeof history.state.lastSectionView === 'undefined' ||
      history.state.lastSectionView === 'main') {

    Voonto.ready.then(function (app) {
      app.when('vtm:ready').then(function() {
        try {
          let tracking = window.vocento.tracking;

          /** default values set ******************************************************************************************/
          TagManager.set({
            seccion: tracking.comscore.voc_se,
            subseccion1: tracking.comscore.voc_s1,
            subseccion2: tracking.comscore.voc_s2,
            subseccion3: tracking.comscore.voc_s3,
            subseccion4: tracking.comscore.voc_s4,
            titular: tracking.comscore.voc_tn,
            tipoDominio: tracking.comscore.voc_pr,
            edicion: tracking.comscore.voc_ed,
            tipoContenido: tracking.comscore.voc_tc,
            tipoContenidoA: tracking.comscore.voc_tcnew,
            plataformaContenido: tracking.comscore.voc_pl,
            sistemaPublicacion: tracking.comscore.voc_pu,
            fechaPrimeraPublicacion: tracking.comscore.voc_fep,
            fechaModificacion: tracking.comscore.voc_fem,
            idioma: tracking.comscore.voc_idi,
            IDEvolok: tracking.comscore.voc_pw_pid,
            firmaAutor: tracking.comscore.voc_au,
            origenContenido: tracking.comscore.voc_or,
            topics: tracking.comscore.voc_top
          });

          /** only home or home section sets ******************************************************************************/
          if (tracking.comscore.voc_tc === 'portada' || tracking.comscore.voc_tc === 'portadilla') {

            /** scrollInfinito & scrollInfinitoHome */
            if (tracking.comscore.voc_tc === 'portada') {
              TagManager.set({scrollInfinitoHome: '1'});
              TagManager.set({scrollInfinito: 'true'});
            }

          /** only news sets **********************************************************************************************/
          } else {

            /** news defaults */
            TagManager.set({
              slot:'',
              modulosRotacion:tracking.comscore.modulosRotacion,
              idNoticia:tracking.comscore.idNoticia
            });

            /** titular */
            if (tracking.comscore.voc_tn.indexOf(".") > -1) {
              TagManager.set({titular:window.voc_tn.substring(0, voc_tn.indexOf("."))});
            } else {
              TagManager.set({titular:tracking.comscore.voc_tn});
            }
          }

          /** Agregamos seccion de tracking para play y summum de buscador **/
          trackUtils.setTrackBuscadorPlaySummum(TagManager);
          /** Agregamos seccion de tracking para detalles archivo Ecommerce **/
          trackUtils.setTrackDetallesArchivo(TagManager);
          /** Agregamos el track para Landings **/
          let landingTrack = trackUtils.setTrackLandingAdblocker(TagManager);

          /** error page set **********************************************************************************************/
          if(tracking.root.httpStatus !== '200') {
            TagManager.set({errorPagina: '404'});
          }

          /** updata vocVars */
          var tagManagerGet = TagManager.get();
          window.voc_se        = tagManagerGet.seccion;
          window.voc_s1        = tagManagerGet.subseccion1;
          window.voc_s2        = tagManagerGet.subseccion2;
          window.voc_s3        = tagManagerGet.subseccion3;
          window.voc_s4        = tagManagerGet.subseccion4;
          window.voc_tn        = tagManagerGet.titular;
          window.voc_pr        = tagManagerGet.tipoDominio;
          window.voc_ed        = tagManagerGet.edicion;
          window.voc_tc        = tagManagerGet.tipoContenido;
          window.voc_tcnew     = tagManagerGet.tipoContenidoA;
          window.voc_ate       = tagManagerGet.contenidoPremium;
          window.voc_pl        = tagManagerGet.plataformaContenido;
          window.voc_pu        = tagManagerGet.sistemaPublicacion;
          window.voc_fep       = tagManagerGet.fechaPrimeraPublicacion;
          window.voc_fem       = tagManagerGet.fechaModificacion;
          window.voc_adp       = tagManagerGet.movilidad;
          window.voc_ho        = tagManagerGet.origenPortada;
          window.voc_idi       = tagManagerGet.idioma;
          window.voc_tusr      = tagManagerGet.tipologiaLogin;
          window.voc_krux      = tagManagerGet.IDKrux;
          window.voc_usrid     = tagManagerGet.IDGigya;
          window.voc_usrag     = tagManagerGet.edad;
          window.voc_usrcp     = tagManagerGet.codigoPostal;
          window.voc_usrgen    = tagManagerGet.genero;
          window.customService = tagManagerGet.sitioRegistro;
          window.voc_pw_pid    = tagManagerGet.IDEvolok;
          window.voc_pw_meter  = tagManagerGet.productoEvolok;
          window.voc_pw_count  = tagManagerGet.nPaginasConsumidas;
          window.voc_pw_max    = tagManagerGet.nPaginasPermitidas;
          window.voc_pw_result = tagManagerGet.autorizacionContenido;
          window.voc_pw_cookie = tagManagerGet.idCookieEvolok;
          window.voc_adb       = tagManagerGet.adBlockers;
          window.voc_adbnew    = tagManagerGet.adBlockersNew;
          window.voc_au        = tagManagerGet.firmaAutor;
          window.id_autor      = tagManagerGet.fichaAutor;
          window.voc_or        = tagManagerGet.origenContenido;
          window.voc_top       = tagManagerGet.topics;

          /* necesitamos implementar await/async */
          /* cutre resolucion para esperar promesa de gigya Ready hay que implementar await y async*/
          if (!landingTrack) {
            TagManager.track();
          }
        } catch (ex) {
          trackUtils.imgTrack('vtm-ready-exception', ex);
          console.error(ex);
        }
      }, function (reason) {
        trackUtils.imgTrack('vtm-ready-error', reason);
        console.error(reason);
      });
    }, function (reason) {
      trackUtils.imgTrack('voonto-ready-error', reason);
      console.error(reason);
    });
  }
} catch (ex) {
  trackUtils.imgTrack('vtm-error-exception', ex);
  console.error(ex);
}



// WEBPACK FOOTER //
// ./src/tracking/vtm.js